'use strict';

module.exports = /* @ngInject */ function ($resource, apiConfig) {

	const HISTORY_ENTRY_LIMIT = 20;
	const BASE = apiConfig.$get().apiUrl;
	const ORDER_PATH = 'order';

	return {
		/**
		 * Get the order history of the currently logged in users company
		 */
		getOrderHistory: $resource(
			`${BASE}/${ORDER_PATH}/history?limit=${HISTORY_ENTRY_LIMIT}`,
			{
				query: {
					method: 'GET',
					isArray: true
				}
			}
		),
		/**
		 * search for orders by orderId
		 */
		searchOrders: $resource(
			`${BASE}/${ORDER_PATH}/search?limit=${HISTORY_ENTRY_LIMIT}&orderId=:orderId`,
			{
				orderId: '@orderId'
			},
			{
				query: {
					method: 'GET',
					isArray: true
				}
			}
		),
		/**
		 * Get linked orders by orderId
		 */
		getLinkedOrdersForOrderByOrderId: $resource(
			`${BASE}/${ORDER_PATH}/relation/:orderId`,
			{
				orderId: '@orderId'
			},
			{
				query: {
					method: 'GET',
					isArray: true
				}
			}
		),
		/**
		 * save a new order link
		 */
		saveOrderLink: $resource(
			`${BASE}/${ORDER_PATH}/relation`,
			{},
			{
				create: {
					method: 'POST',
					data: '@relation'
				}
			}
		),
		/**
		 * delete an order relation
		 */
		deleteOrderLink:  $resource(
			`${BASE}/${ORDER_PATH}/relation/:orderId`,
			{
				orderId: '@orderId'
			},
			{
				query: {
					method: 'DELETE'
				}
			}
		),
	};

}
